import { EBeneficiaryType, ECreditApplicationStatus, EDecision, EFinancingProgram } from '@if/core/types'
import { useUser } from '@src/contexts/AppContext'
import { useSaveCreditApplicationDraft } from '@src/data/api/credit-api/credit-api'
import { useMerchantById } from '@src/data/api/merchants-api/merchants-api'
import useFeatureFlags from '@src/hooks/config-hooks'
import { CreditApplication, DraftCreditApplicationSchema } from '@src/types/CreditApplicationSchema'
import { useState, type JSX } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { adjustCreditApplicationYearsForApi } from '../ViewCreditApplicationPage/credit-hooks'
import CreditApplicationForm from './components/CreditApplicationForm'

const CreateCreditApplicationPage = (): JSX.Element => {
  const user = useUser()
  const { financingProgramId } = useParams<{ financingProgramId: EFinancingProgram }>()
  const [merchant] = useMerchantById(user?.merchantId ?? '')
  const { isFetchingFeatureSwitch } = useFeatureFlags()

  const [saveCreditAppMutation, isPending, isError, reset, error] = useSaveCreditApplicationDraft()
  const [creditApplication] = useState<CreditApplication>({
    ...(DraftCreditApplicationSchema().getDefault() as unknown as CreditApplication),
  })
  const navigate = useNavigate()

  const onSave = async (data: Partial<CreditApplication>) => {
    if (!data.beneficiaryTypeId) data.beneficiaryTypeId = EBeneficiaryType.Applicant
    adjustCreditApplicationYearsForApi(data)
    await saveCreditAppMutation(data).then((creditApp) => {
      reset()
      if (creditApp.status === ECreditApplicationStatus.Draft) navigate(`/`)
      else {
        navigate(`/credits/${creditApp.financingProgramId}/${creditApp.id}`)
      }
    })
  }
  const isPrequalComplete =
    creditApplication?.prequalificationDecision?.decision === EDecision.Approved ||
    (creditApplication?.prequalificationDecision?.decision === EDecision.Refused &&
      creditApplication?.applicant?.hasCreditReport === true)
  return (
    <div>
      {!isFetchingFeatureSwitch && (
        <CreditApplicationForm
          merchant={merchant}
          creditApplication={creditApplication}
          onSave={onSave}
          isPending={isPending}
          isError={isError}
          serverErrors={error}
          financingProgramId={financingProgramId!}
          isPrequalComplete={isPrequalComplete}
          isApplicantSinNeeded={false}
          isCoapplicantSinNeeded={false}
        />
      )}
    </div>
  )
}

export default CreateCreditApplicationPage
